import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">מדיניות פרטיות</h1>
          <p className="text-gray-300 text-lg">איך אנו מטפלים במידע האישי שלך</p>
        </div>

        <div className="bg-black/50 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-8 space-y-8">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-8">
            <p className="text-amber-300 text-sm">
              <strong>הערה חשובה:</strong> מדיניות הפרטיות הבאה הינה טיוטה בלבד ואינה מהווה ייעוץ משפטי. 
              יש להתייעץ עם עורך דין מוסמך המתמחה בחוק הגנת הפרטיות התשמ"א-1981 ותקנות הגנת הפרטיות.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              1. איסוף מידע
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>אנו עשויים לאסוף את סוגי המידע הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li><strong>מידע אישי:</strong> שם, טלפון, דוא"ל, כתובת</li>
                <li><strong>מידע טכני:</strong> כתובת IP, סוג דפדפן, מערכת הפעלה</li>
                <li><strong>מידע שימוש:</strong> דפים שבוקרו, זמן שהייה באתר</li>
                <li><strong>עוגיות (Cookies):</strong> לשיפור חוויית השימוש</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              2. שימוש במידע
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>אנו משתמשים במידע לצרכים הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>מתן שירותים ומכירת רכבים</li>
                <li>יצירת קשר עם לקוחות פוטנציאליים</li>
                <li>שיפור השירות ופיתוח האתר</li>
                <li>שיווק ופרסום (בהסכמתך)</li>
                <li>עמידה בדרישות חוקיות</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              3. שיתוף מידע עם צדדים שלישיים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>איננו מוכרים או מעבירים מידע אישי לצדדים שלישיים, למעט:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>ספקי שירות טכניים (אחסון אתרים, תחזוקה)</li>
                <li>רשויות חוק בהתאם לדרישה משפטית</li>
                <li>בהסכמתך המפורשת</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              4. אבטחת מידע
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>אנו נוקטים באמצעי אבטחה הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>הצפנת SSL למידע רגיש</li>
                <li>שמירת מידע בשרתים מאובטחים</li>
                <li>הגבלת גישה למידע לצוות מורשה בלבד</li>
                <li>עדכונים ביטחוניים שוטפים</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              5. זכויותיך
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>בהתאם לחוק הגנת הפרטיות, זכאי אתה:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>לדעת איזה מידע אנו שומרים עליך</li>
                <li>לתקן מידע שגוי</li>
                <li>לבקש מחיקת מידע</li>
                <li>לבטל הסכמה לקבלת חומר פרסומי</li>
                <li>להגיש תלונה לרשות הגנת הפרטיות</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              6. עוגיות (Cookies)
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                האתר משתמש בעוגיות לשיפור חוויית הגלישה ולניתוח תנועה באתר.
              </p>
              <p>
                באפשרותך לחסום עוגיות דרך הגדרות הדפדפן, אך זה עלול להשפיע על פונקציונליות האתר.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              7. צור קשר
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>לשאלות בנוגע למדיניות הפרטיות ניתן לפנות אלינו:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>טלפון: 058-7019669</li>
                <li>דוא"ל: privacy@jclassmotors.co.il</li>
                <li>כתובת: תל אביב, ישראל</li>
              </ul>
              <p className="mt-4">
                <strong>רשות הגנת הפרטיות:</strong> gov.il/privacy | טלפון: 02-6663888
              </p>
            </div>
          </section>

          <div className="border-t border-amber-500/30 pt-6 mt-8">
            <p className="text-gray-400 text-sm text-center">
              עדכון אחרון: {new Date().toLocaleDateString('he-IL')} | 
              J CLASS MOTORS - כל הזכויות שמורות | מדיניות זו כפופה לחוק הגנת הפרטיות התשמ"א-1981
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;